import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tl-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit {
  constructor() {}

  ngOnInit() { }
}
